/**
 * Ворота аналитики в браузере (ISSUE-132): обходчики с JS (облака, старые Chrome) открывают игру и шлют `app_open`
 * и `session_start`, хотя ни разу не касаются экрана. В браузере события ждут первого действия игрока — касания,
 * клика или клавиши — и уходят все разом; без действия не уходят. Mini App пропускает сразу: initData есть только
 * у настоящего клиента Telegram. Просмотр страницы (pageview) идёт через те же ворота. Вход, бой и журналы волн ворота не трогают.
 */
/** События, которые копятся до первого действия; лишние отбрасываются (обходчик с открытой вкладкой). */
export const GATE_MAX = 100;

/** DOM-события, которые считаются действием игрока. */
export const GATE_EVENTS = ["pointerdown", "keydown", "touchstart"] as const;

export interface GateDeps<T> {
  /** Ворота открыты сразу (Mini App). */
  open: boolean;
  target: Pick<EventTarget, "addEventListener" | "removeEventListener">;
  send(item: T): void;
}

export function createInteractionGate<T>(deps: GateDeps<T>): (item: T) => void {
  let open = deps.open;
  const held: T[] = [];
  const onAction = (): void => {
    if (open) return;
    open = true;
    for (const e of GATE_EVENTS) deps.target.removeEventListener(e, onAction, true);
    for (const e of held.splice(0)) deps.send(e);
  };
  if (!open) for (const e of GATE_EVENTS) deps.target.addEventListener(e, onAction, true);
  return (item) => {
    if (open) deps.send(item);
    else if (held.length < GATE_MAX) held.push(item);
  };
}
